import script from "./LocalSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocalSettings.vue?vue&type=script&setup=true&lang=ts"

import "./LocalSettings.vue?vue&type=style&index=0&id=a3a4f64c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3a4f64c"]])

export default __exports__